import { budgetApiServiceStore } from 'src/tpbp-json-api-handler/budget/budgetApiServiceStore'
import type { Scalar } from 'src/tpbp-core/models/global.type'

export const getBudgetEntryKindLabel = (entryKind: Scalar) => {
  const entryKindConfiguration =
    budgetApiServiceStore.getEntryKindConfiguration(entryKind)

  return entryKindConfiguration?.entryKindLabel || ''
}
